var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
var AboutUsOurPassion = /** @class */ (function (_super) {
    __extends(AboutUsOurPassion, _super);
    function AboutUsOurPassion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AboutUsOurPassion.prototype.render = function () {
        return (React.createElement("div", { className: "c-about-us-our-passion" },
            React.createElement("div", { className: "c-about-us-our-passion__header" },
                React.createElement("img", { src: "/images/icons/about-us-passion.svg", alt: "" }),
                React.createElement("h1", { className: "c-title c-title--style2" }, this.props.t('about_us.our_passion.title'))),
            React.createElement("div", { className: "c-about-us-our-passion__content" },
                React.createElement("div", { className: "c-about-us-our-passion__content__block" },
                    React.createElement("h2", { className: "c-title c-title--style2" }, this.props.t('about_us.our_passion.block1.title')),
                    React.createElement("p", null,
                        React.createElement(Trans, { i18nKey: "about_us.our_passion.block1.content" },
                            React.createElement("b", null),
                            React.createElement("br", null)))),
                React.createElement("div", { className: "c-about-us-our-passion__content__block h-padding-top--40 h-padding-top--md-0" },
                    React.createElement("h2", { className: "c-title c-title--style2" }, this.props.t('about_us.our_passion.block2.title')),
                    React.createElement("p", null,
                        React.createElement(Trans, { i18nKey: "about_us.our_passion.block2.content" },
                            React.createElement("b", null),
                            React.createElement("a", { href: this.props.t('navigation.links.help_center.url'), target: "_blank" })))))));
    };
    return AboutUsOurPassion;
}(React.Component));
export default withTranslation()(AboutUsOurPassion);
